import { useState, useEffect } from "react";
import { useIRBDocumentsData, useRequestProgressDataByRequestId } from "./index";

export const useIRBDocumentsWithFallback = (id, persona) => {
  const [useFallback, setUseFallback] = useState(false);
  
  // Primary data source
  const primaryData = useIRBDocumentsData(id);
  
  // Fallback data source - only call if needed
  const fallbackData = useRequestProgressDataByRequestId(useFallback ? id : null, persona);
  
  // Determine when to use fallback
  useEffect(() => {
    if (primaryData.error && primaryData.error.response?.status !== 404 && !primaryData.loading) {
      setUseFallback(true);
    }
  }, [primaryData.error, primaryData.loading]);
  
  // Return the appropriate data source
  if (useFallback) {
    // Map fallback data to match the expected structure
    let parsedFormData = null;
    if (fallbackData.filledForm?.value) {
      try {
        parsedFormData = JSON.parse(fallbackData.filledForm.value);
      } catch (e) {
        console.error("Error parsing fallback form data:", e);
      }
    }
    
    return {
      loading: fallbackData.loading,
      error: fallbackData.error,
      data: fallbackData.requestProgress, // Use requestProgress as the data object
      parsedFormData,
      subforms: fallbackData.subforms,
      comments: fallbackData.comments,
      requestDetails: {
        reference_number: fallbackData.requestProgress?.request?.IRB_Ref || 
                         fallbackData.requestProgress?.request?.reference_number || 
                         id
      },
      requestId: fallbackData.requestProgress?.request?.id,
      requestProgressId: fallbackData.requestProgress?.id,
      filledForm: fallbackData.filledForm,
      irbRefId: fallbackData.requestProgress?.request?.id,
      isUsingFallback: true
    };
  }
  
  // Return primary data
  return {
    loading: primaryData.loading,
    error: primaryData.error,
    data: primaryData.data,
    parsedFormData: primaryData.parsedFormData,
    subforms: primaryData.subforms,
    comments: primaryData.comments,
    requestDetails: primaryData.requestDetails,
    requestId: primaryData.requestId,
    requestProgressId: primaryData.requestProgressId,
    filledForm: primaryData.data?.filledForm,
    irbRefId: primaryData.irbRefId,
    isUsingFallback: false
  };
}; 